import React, { useState } from 'react';
import { Plus, Save } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function ManualLeadModal({ datasets, defaultDatasetId, onClose }) {
  const [form, setForm] = useState({
    dataset_id: defaultDatasetId || '', business_name: '', phone: '', email: '', website: '',
    address: '', city: '', category: '', notes: '', source: 'manual'
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!form.dataset_id) return toast.error('Seleccioná una base de datos');
    if (!form.business_name && !form.phone) return toast.error('Ingresá al menos nombre o teléfono');
    setSaving(true);
    try { await api.post('/leads', form); toast.success('Lead creado'); onClose(); }
    catch (err) { toast.error(err.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const fields = [
    { key: 'business_name', label: 'Nombre del negocio', placeholder: 'Ej: Inmobiliaria Juanito' },
    { key: 'phone', label: 'Teléfono', placeholder: 'Ej: 1140996263' },
    { key: 'email', label: 'Email', placeholder: 'Ej: contacto@negocio.com' },
    { key: 'website', label: 'Sitio web', placeholder: 'Ej: www.negocio.com' },
    { key: 'address', label: 'Dirección', placeholder: 'Ej: Av. Corrientes 1234' },
    { key: 'city', label: 'Ciudad', placeholder: 'Ej: Buenos Aires' },
    { key: 'category', label: 'Sector', placeholder: 'Ej: Inmobiliaria' },
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h2><Plus size={20} style={{ marginRight: 8, verticalAlign: 'middle' }} />Agregar lead manual</h2>
        <div className="form-group">
          <label>Base de datos</label>
          <select value={form.dataset_id} onChange={e => setForm({...form, dataset_id: e.target.value})}>
            <option value="">Seleccionar base de datos...</option>
            {datasets?.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
          </select>
        </div>
        {fields.map(f => (
          <div key={f.key} className="form-group" style={{ marginBottom: 10 }}>
            <label style={{ fontSize: 12 }}>{f.label}</label>
            <input value={form[f.key]} onChange={e => setForm({...form, [f.key]: e.target.value})} placeholder={f.placeholder} />
          </div>
        ))}
        <div className="form-group" style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 12 }}>Fuente</label>
          <select value={form.source} onChange={e => setForm({...form, source: e.target.value})}>
            <option value="manual">Manual</option><option value="referido">Referido</option>
            <option value="llamada">Llamada entrante</option><option value="evento">Evento/Networking</option>
            <option value="otro">Otro</option>
          </select>
        </div>
        <div className="form-group">
          <label style={{ fontSize: 12 }}>Notas</label>
          <textarea value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} placeholder="Notas iniciales..." rows={3} style={{ resize: 'vertical' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
          <button className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button className="btn btn-primary" onClick={save} disabled={saving}><Save size={14} /> {saving ? 'Guardando...' : 'Guardar lead'}</button>
        </div>
      </div>
    </div>
  );
}
